"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _productListContext = require("./productListContext");
Object.keys(_productListContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _productListContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _productListContext[key];
    }
  });
});
